import { useMemo } from 'react';
import { useShopConfig } from './shopConfig';
import { useDefaultShopStyles } from './useDefaultShopStyles';

type IconColorPayload = {
  iconColor: string;
  iconHoverColor: string;
};

// Gets the icon color from the shop config
export const useIconColor = (): IconColorPayload => {
  const { css: shopCss } = useShopConfig();
  const defaultShopStyles = useDefaultShopStyles();

  return useMemo(() => {
    // Use Contentful icon color if it's present
    if (shopCss?.icon?.color) {
      return {
        iconColor: shopCss?.icon?.color,
        iconHoverColor: shopCss?.icon?.hoverColor || shopCss?.icon?.color,
      };
    }

    // Fall back to subtitle1 color (nav bar)
    if (shopCss?.subtitle1?.color) {
      return {
        iconColor: shopCss?.subtitle1?.color,
        iconHoverColor: shopCss?.subtitle1?.color,
      };
    }

    // Otherwise use the shop colors
    return {
      iconColor: defaultShopStyles.shopColor100,
      iconHoverColor: defaultShopStyles.shopColor80,
    };
  }, [shopCss, defaultShopStyles]);
};
